const pt_BR = {
  LAYOUT: {
    SEND: "Enviar",
    CORS: "Falha ao conectar ao servidor, tente novamente mais tarde. (CORS)",
    NEXT_PAGE: "Próximo",
    PREV_PAGE: "Anterior",
    ON: "LIGADO",
    OFF: "DESLIGADO",
    TITLE: "Título",
    CONTENT: "Conteúdo",
    BUTTON: "Botão",
    OR: "ou",
    DISMISS: "Dispensar",
    BACK: "Voltar",
    REGION: "Região",
    COUNTRY: "País",
    COUNTRYCOUNT: "Quantidade de Países",
    UPDATE: "Última atualização",
    SEARCH_RESULTS: "Resultados da busca",
    DOWNLOAD: "Baixar",
    UNIT_PL: "Usuário",
    UNIT_MIN: "Minuto",
    UNIT_SEC: "Segundo",
    UNIT_Y: "Ano",
    UNIT_M: "Mês",
    OFFDAY: "Dia de folga",
    WORKDAY: "Dia útil",
    D_0: "Domingo",
    D_1: "Segunda-feira",
    D_2: "Terça-feira",
    D_3: "Quarta-feira",
    D_4: "Quinta-feira",
    D_5: "Sexta-feira",
    D_6: "Sábado",
    LAST_WEEK: "Semana passada",
    LAST_MONTH: "Último mês",
    LAST_THREE_MONTHS: "Últimos 3 meses",
    SATRT_DATE: "Data de início",
    END_DATE: "Data de término",
    EMPTY_FILTER: "Nenhum resultado encontrado. Tente outros filtros",
    EMPTY_ROOM: "Por favor, selecione primeiro a sala de chat na lista",
    GET_NEW_MESSAGE: "Você recebeu uma nova mensagem.",
    GET_NEW_LINK: "Você recebeu um novo link.",
    GET_NEW_FILE: "Você recebeu um novo arquivo.",
    MSG_OFFLINE:
      "Atualmente offline, reconecte-se à Internet para continuar trabalhando.",
    MSG_RECONNECT: "Conexão restaurada.",
    MSG_ONLOGOUT:
      "Como você ficou inativo por muito tempo, para proteger a segurança das suas informações, o sistema fez logout automaticamente. Por favor, faça login novamente.",
    MSG_ONCLOSE:
      "Erro ou interrupção na conexão do chat, tentativa automática de reconexão em 10 segundos.",
    MSG_LOGIN_AGAIN: "Por favor, faça login novamente.",
    MSG_YOU: "Você",
    MSG_RETRACT: "retirou a mensagem.",
    NEWMSG: "Você tem uma nova mensagem",
    BEFORE_CHANGE_ROOM:
      "Você possui mensagens não enviadas, que serão apagadas ao trocar de sala.",
    DWONLOAD_ERROR: "Arquivo não encontrado.",
    DWONLOAD_ERROR401: "Permissão negada, faça login primeiro.",
    CONNECTION_STATE: "Status da conexão",
    DISCONNECTED: "Conexão perdida, tente mais tarde.",
    RECONNECTING: "Reconectando.",
    ISTYPING: "está digitando",
    AGENTIDLE:
      "Você tem uma sala de chat {roomName} pendente há mais de {min} min.",
    CONFIRM: "Confirmar",
    TOTAL_ITMES: "{total} itens.",
    ATTACHMENT: "Anexo",
    NEW_VERSION: "Beta Version",
    OLD_VERSION: "Current Version",
  },
  RULE: {
    FORMATE_ERROR: "Formato incorreto.",
    REQUIRED: "Obrigatório",
    PASSWORD: "Por favor, insira a senha.",
    PASSWORD_AGAIN: "Por favor, insira a senha novamente.",
    PASSWORD_CONFIRM: "As senhas inseridas não coincidem!",
    PASSWORD_LEN: "De 6 a 12 caracteres.",
    CANNED_KEYWORD:
      'Deve começar com o símbolo "#" (meia largura), limite de 2 a 10 caracteres',
    EMAIL_FORMATE: "Por favor, insira um email válido.",
    EMAIL_FORMATE2: "Por favor, insira um endereço de email ASUS válido.",
    PASSWORD_RULE:
      "Nota: A senha deve ter entre 15 e 20 caracteres e conter pelo menos três dos seguintes tipos de caracteres: números, letras maiúsculas, letras minúsculas e caracteres especiais.",
  },
  BUTTON: {
    LATER: "Depois",
    RESET: "Redefinir",
    CANCEL: "Cancelar",
    SAVE: "Salvar",
    CONFIRM: "Confirmar",
    CREATE: "Criar",
    SELECT: "Selecionar",
    SEND: "Enviar",
    EDIT: "Editar",
    VIEW: "Revisar",
    SETTING: "Configurar",
    ADD: "Adicionar",
    ACCEPT: "Aceitar",
    REJECT: "Rejeitar",
    JOIN_ROOM: "Entrou na sala de chat",
    UNJOIN_ROOM: "Recusou entrar na sala de chat",
    INVITE: "Convidar",
    SEARCH: "Buscar",
    MORE: "Mais",
    DELETE: "Excluir",
    BACK: "Voltar",
    NEXT: "Próximo",
    PREV: "Anterior",
    CHANGE: "Alterar",
    CHANGEPSW: "Alterar senha",
    EXPORT: "Exportar",
    SELECT_EXPORT: "Exportar selecionados",
    IMPORT: "Importar",
    UPLOAD: "Enviar",
    UPDATE: "Atualizar",
    PUBLISHED: "Publicar",
    SCHEDULE: "Agendar",
    ACTION: "Ação",
    MANAGE: "Gerenciar",
    MONITOR: "Monitorar",
    TRANSFER: "Transferência manual",
    AUTOTRANSFER: "Transferência automática",
    SELECTFILE: "Selecionar arquivo",
    GSM_SEARCH: "Consulta GSM",
    HISTORY_LOG: "Ver histórico do chat",
    CUSTOMER_CREATE_EDIT_NOTE: "Editar",
    BACK_LOGIN: "Voltar ao login",
  },
  FORM: {
    TO: "até",
    STARTTIME: "Hora de início",
    ENDTIME: "Hora de término",
    STARTDATE: "Data de início",
    ENDDATE: "Data de término",
    OPT_PUBLISHED: "Publicado",
    OPT_UNPUBLISHED: "Não publicado",
    OPT_RECALL: "Removido",
    OPT_EXPIRED: "Expirado",
    OPT_GENERAL: "Geral",
    OPT_URGENT: "Urgente",
    OPT_NONSERVICE: "Sem serviço",
    OPT_EC_GENERAL: "EC-Geral",
    OPT_EC_URGENT: "EC-Urgente",
    OPT_EC_NONSERVICE: "EC-Sem Serviço",
    OPT_YES: "Sim",
    OPT_NO: "Não",
  },
  MODULE: {
    LOADINGOPTIONS: "Carregando opções...",
    SELECT_ALL: "Selecionar tudo",
    SELECT_REGION: "Selecione a região",
    SELECT_COUNTRY: "Selecione o país",
    SELECT_REGION_FIRST: "Selecione a região primeiro.",
    SELECT_COUNTRY_FIRST: "Selecione o país primeiro.",
    SELECT_SKILL: "Selecione a habilidade",
    SELECT_AGENT: "Selecione o agente",
    SELECT_STATUS: "Selecione o status",
    COUNTRY_NOASP: "Nenhum ASP estabelecido para este país",
    COUNTRY_NOSKILL: "Nenhuma habilidade estabelecida para este país",
    SELECT_ASP: "Selecione o ASP",
    SELECT_ASP_FIRST: "Selecione o ASP primeiro.",
    ASP_NOSKILL: "Este ASP ainda não adicionou nenhuma habilidade",
  },
  NOTIFICATION: {
    STATUS_CHANGE_SUCCESS: "Status alterado com sucesso.",
    LOGIN_FAIL: "Falha no login",
    LOGIN_EXPIRE: "Senha expirada. Por favor, redefina.",
    LOGIN_SUCCESS: "Bem-vindo de volta",
    LOGOUT_SUCCESS: "Logout realizado com sucesso.",
    VERIFY_ERROR: "Código de verificação incorreto",
    SYS: "Sistema",
    CONFIRM: "Confirmar",
    CANCEL: "Cancelar",
    LOGOUT: "Logout",
    DELETE: "Excluir",
    SUCCESS: "Sucesso",
    ERROR: "Erro",
    NOTICE: "Aviso",
    ALERT: "Alerta",
    NODATA: "Dados não encontrados.",
    SOMETHING_WENT_WRONG: "Ocorreu um erro desconhecido.",
    CREATE_SUCCESS: "Dados adicionados com sucesso",
    SEND_SUCCESS: "Dados enviados com sucesso",
    UPDATE_SUCCESS: "Dados atualizados com sucesso",
    SAVE_SUCCESS: "Dados salvos com sucesso",
    DELETE_SUCCESS: "Dados excluídos com sucesso",
    SCHEDULE_SUCCESS: "Dados agendados com sucesso",
    PUBLISH_SUCCESS: "Dados publicados com sucesso",
    SETTING_SUCCESS: "Dados configurados com sucesso",
    PASSWORD_CHANGE_SUCCESS:
      "Senha alterada com sucesso. Use a nova senha no próximo login.",
    SELECT_READY_AGENT:
      'Por favor, escolha o agente com status "Pronto" como prioridade',
    CONFIRM_LOGOUT: "Deseja sair?",
    CONFIRM_LOGOUT_1:
      "O chat está em andamento, tem certeza de que deseja sair?",
    CONFIRM_LOGOUT_2: "Deseja sair?",
    CONFIRM_DELETE: "Deseja excluir este item?",
    CONFIRM_DELETE_SKILL: "Deseja excluir esta habilidade?",
    CONFIRM_DELETE_NOTES: "Deseja excluir esta observação?",
    CONFIRM_DELETE_ASP: "Deseja excluir este agente (ASP)?",
    CONFIRM_DELETE_BULLETIN: "Deseja excluir este boletim?",
    CONFIRM_DELETE_COUNTRY: "Deseja excluir este país?",
    CONFIRM_DELETE_CANNED: "Deseja excluir esta mensagem rápida?",
    CONFIRM_PUBLISH: "Deseja publicar o anúncio?",
    CONFIRM_SCHEDULE: "Deseja adicionar este anúncio à programação?",
    CONFIRM_CREATE_COUNTRY: "Deseja adicionar este país/região?",
    CONFIRM_CREATE_ASP: "Deseja adicionar este ASP?",
    CONFIRM_CREATE_SKILL: "Deseja adicionar esta habilidade?",
    CONFIRM_CREATE_ACC: "Deseja adicionar esta conta?",
    CONFIRM_LEAVE_GROUP:
      "Após sair do grupo, você não receberá notificações push do grupo.",
    CONFIRM_LEAVE_GROUP_MSG:
      "Tem certeza de que deseja sair deste grupo de chat?",
    CONFIG_ANGENT_UNSEND: "Não é permitido retirar mensagens.",
  },
  NAV: {
    HOME: "Início",
    CHAT: "Sala de Chat",
    HISTORY: "Histórico de Chat",
    CHATCASE: "Caso de Chat",
    REPORT: "Relatório",
    ACD_MONITOR: "Monitor ACD",
    DASHBOARD: "Painel",
    SETTING: "Configurações",
    NOTIFY: "Notificação",
  },
  LOGIN: {
    EMAIL: "Email",
    PSW: "Digite a senha",
    REMEMBER: "Lembrar meu ID",
    LOGIN: "Entrar",
    FORGET_PSW: "Esqueceu a senha",
    ENTER_EMAIL: "Digite seu email",
    ENTER_PSW: "Digite a nova senha",
    ENTER_PSW2: "Confirme a nova senha",
    RESET_SUCCESS: "Senha redefinida com sucesso",
    RESET_SUCCESS_INFO: "Faça login novamente com a nova senha.",
    ENTER_VALIDATE_CODE:
      "Digite o código de verificação (não diferencia maiúsculas de minúsculas)",
    SENT_1: "Um link para redefinir a senha foi enviado para seu email",
    SENT_2: "Email enviado para",
    SENT_3:
      "Por favor, verifique sua caixa de entrada. Se o email não aparecer, verifique a caixa de spam. (Você pode fechar esta página)",
    ENTER_CODE: "Código de verificação do chat",
    CODE_SENT: "O email de verificação foi enviado.",
    RESENT: "Reenviar",
    VERIFY_FAIL: "Falha na verificação",
  },
  HOME: {
    SERVICE_SKILL: "Habilidade de Serviço",
    ORDER_RATE: "Taxa de criação de caso de chat",
    WORK_ASSIGNMENT: "Distribuição de tempo de trabalho",
    CHART_WORK: "Trabalho",
    CHART_BREAK: "Intervalo",
    PICKUP_RATE: "Informação em tempo real",
    TH_SKILL: "Habilidade",
    TH_INLINE: "Qtd. de usuários online",
    TH_ONLINE: "Qtd. na fila",
    TH_SERVICED: "Qtd. concluída",
    TH_PICKUPRATE: "Percentual do produto",
    SAT: "Satisfação",
    TH_SAT: "Satisfeito",
    TH_UNSAT: "Insatisfeito",
    CODE: "Código de verificação de email do dia",
  },
  CHAT: {
    CL: {
      TITLE: "Chat com Cliente",
      MYCLIENT: "Meu Cliente",
      IDLE: "Inativo",
      NO_CLIENT: "Nenhuma notificação do cliente ainda",
      ISSERVICE: "Status do serviço",
      HEAD: {
        TRIGGER_SURVEY: "Lembrete de pesquisa de satisfação",
        SURVEY_TEXT: "{agent} has sent a satisfaction survey",
        TRIGGER_IDLE: "Lembrete de inatividade",
        TRANSFER: "Transferir",
        FINISH: "Encerrar o Chat",
        BLACK: "Bloquear o Cliente (Lista negra)",
        NOTE: "Observação",
        COPY_BTN: "Copiar para a área de transferência.",
      },
      FINISH: {
        TITLE: "Encerrar a conversa",
        REASON: "Motivo para encerrar a conversa",
        OTHER_REASON: "Outro motivo",
        REASON_1: "Serviço concluído",
        REASON_2: "Cliente não responde",
        REASON_3: "Cliente aceita desconexão",
        REASON_4: "Outro",
        REASON_5: "Agendar serviço remoto",
      },
      TRANSFER: {
        TITLE: "Configuração de Transferência",
        REASON: "Selecione o motivo da transferência",
        REASON_1: "Cliente indica",
        REASON_2:
          "Linha de produto incorreta (depois, selecione o produto correto)",
        REASON_3: "Reclamação grave do cliente (transferir para supervisor)",
        REASON_4: "Cliente precisa de assistência WebRTC",
        REASON_5: "Outro",
        REASON_OTHER: "Por favor, preencha outros motivos",
        F_SKILL: "Suporte ao Produto (Habilidade)",
        TH_AGENT: "Nome do agente",
        TH_SKILL: "Habilidade do produto",
        TH_STATUS: "Status",
        NO_AGENT: "Nenhum agente/supervisor disponível para transferência.",
        SELECAGENT: "Selecione o Agente",
        SELECTED_AGENT: "Agente Selecionado",
        UNSELECTED_AGENT: "Selecione o agente para transferir",
        CONFIRM_SELECTED_AGENT: "Transferir para",
        A_ING: "Aguarde. A transferência automática está em andamento",
        M_ING: "Aguarde. Estamos transferindo você para",
        A_SUCCESS: "Transferência automática realizada com sucesso.",
        M_SUCCESS: "Transferido com sucesso para",
        AM_FAIL:
          "Falha na transferência. Por favor, preencha novamente o motivo e atribua a outro agente.",
      },
      NOTE: {
        TITLE: "Observação para este cliente",
        CREATE: "Criar nova observação",
        EDIT: "Editar observação",
        CREATE_NOTE: "Até 100 caracteres",
        TH_DATE: "Data",
        TH_AGENT: "Agente",
        TH_CONTENT: "Conteúdo",
      },
      INFO: {
        TITLE: "Informações da sala de chat.",
        SUBTITLE_1: "Informações do cliente.",
        SUBTITLE_2: "Consulta de produto",
        SUBTITLE_3: "Histórico de chat",
        SUBTITLE_4: "Observação",
        CU_AVATAR: "Foto de perfil",
        CU_NAME: "Nome",
        CU_EMAIL: "Email",
        CU_ORDER_NO: "Número do pedido",
        CU_TEL: "Contato",
        CU_TIME: "Hora local",
        CU_LOCAL: "Localização",
        CU_DEVICE: "*Dispositivo",
        CU_PLATFORM: "Plataforma",
        PD_TYPE: "*Tipo de problema",
        PD_SKILL: "Produto",
        PD_SKILL_NUM: "Modelo do produto",
        PD_ID: "SN do modelo do produto",
        PD_WARRANTY: "Território da garantia",
        PD_WARRANTYEND: "Fim da garantia",
        PD_WARRANTY_REMOTE: "Garantia (somente serviço remoto)",
        PD_REMOTE: "Extensão de garantia (somente serviço remoto)",
        PROBLEM_NOTE: "Nota do problema",
        HS_VIEWLOGS: "Ver registros",
        HS_TODAYINLINE: "Qtd. de entradas hoje",
        HS_INLINE: "Qtd. de entradas em 30 dias",
        HS_LAST_SKILL: "Produto anterior",
        HS_LAST_SKILL_NUM: "Modelo anterior",
        HS_MODEL_QUICKSEARCH: "Busca rápida",
        HS_MODEL_EMPTY: "Nenhum registro",
        HS_MODEL_1DAY: "Hoje",
        HS_MODEL_3DAY: "Últimos 3 dias",
        HS_MODEL_7DAY: "Últimos 7 dias",
        EDIT_PRODUCT: "Editar informações do produto",
        GSM_INFO: "Informações GSM",
        SN_LOCK:
          "(SN Locked) This device is not eligible for ASUS RMA requests. Please contact the original reseller for service.",
        STOLEN: "This product has been marked as 'Stolen.'",
      },
    },
    IN: {
      TITLE: "Chat Interno",
      CREATE: {
        TITLE: "Criar grupo de chat",
        ENTER_GROUPNAME: "Digite o nome do grupo",
      },
      INFO: {
        TITLE: "Informações da sala",
        SUBTITLE_1: "Lista de grupos",
        INVITE: "Convidar o agente",
      },
      F_SEARCHNAME: "Buscar nome do agente",
      TH_NICKNAME: "Apelido",
      TH_USERNAME: "Nome de usuário",
      TH_SKILL: "Habilidade",
      TH_STATUS: "Status",
      TH_UNSELECT: "Selecionar agente",
      TH_SELECTED: "Agente selecionado",
    },
    UPLOAD: {
      TITLE: "Enviar arquivo",
      DROG: "Arraste e solte o arquivo aqui",
      FORMATE: "Formato do arquivo",
      SIZE: "Tamanho máximo",
      TH_NAME: "Nome",
      TH_SIZE: "Tamanho",
      TH_TYPE: "Formato",
      SELECT_AT_LEAST_IMAGE: "Escolha pelo menos uma imagem",
      SELECT_AT_LEAST_FILE: "Escolha pelo menos um arquivo",
      NOT_SUPPORT: "Formato de arquivo não suportado, selecione outro arquivo!",
      FILE_LIMIT:
        "Alguns arquivos excedem o limite. O limite máximo é {size}MB",
    },
    LINK: {
      TITLE: "Adicionar hiperlink",
      TEXT: "Digite o texto",
    },
    CANNED: {
      TITLE: "Mensagens rápidas",
      NO_GROUP: "Você não criou nenhum grupo",
      SELECT_GROUP: "Selecionar grupo",
      SELECT_GROUP_FIRST: "*Selecione o grupo primeiro",
      NO_CATE: "Você não criou nenhuma categoria",
      SELECT_CATE: "Categoria",
      ENTER_KEYWORD: "Digite o filtro de palavra-chave",
      ENTER_SHORTCUT: "Digite o filtro de atalho",
      ENTER_SHORTCUT_OR_GROUP: "Digite o atalho ou pesquise o grupo",
      NO_CANNED: "Você não criou nenhuma mensagem rápida",
    },
    CHATCASE: {
      PROBLEM: {
        COPY_KB: "Copiar e citar",
        COPY_SUCCESS: "KB foi copiado para a área de transferência.",
        CLOSE: "Fechar",
        SELECT: "Citar",
      },
      CREATE_CHATCASE: {
        ALERT: "Dica: KB não foi selecionado",
      },
    },
  },
  HISTORY: {
    TITLE: "Histórico de Chat",
    NAV_TITLE1: "Histórico de Chat",
    NAV_TITLE2: "Histórico de Chat Interno",
    NAV_TITLE3: "Pesquisa de Conversa de Chat",
    NAV_TITLE4: "Histórico de Videochamadas",
    KEYWORDL: "Palavra-chave",
    TH_DATE: "Data",
    TH_STARTTIME: "Hora de início",
    TH_CUST: "Nome do Usuário",
    TH_CUSTASUSACC: "Conta ASUS",
    TH_PRODUCT: "Produto",
    TH_PHONE: "Telefone do Usuário",
    TH_EMAIL: "Email do Usuário",
    TH_SN: "SN",
    TH_SESSIONID: "ID da Sessão",
    TH_ROOMID: "ID da Sala",
    TH_GROUPNAME: "Nome do Grupo",
    TH_CREATOR: "Criador",
    TH_AGENTNAME: "Nome do Agente",
    TH_AGENTEMAIL: "Email do Agente",
    TH_TALKTIME: "Tempo de Conversa(s)",
    COPY_BTN: "Copiar para a área de transferência.",
    COPY_SUCCESS:
      "Conteúdo da sala de chat salvo com sucesso na área de transferência.",
    SELECT_TYPE: "Por favor, selecione um formato de arquivo para exportação.",
  },
  CHATCASE: {
    TITLE: "Caso de Chat (Beta)",
    TEMP: "Rascunho temporário, ainda não salvo.",
    CREATE_CASE: "Criar Caso de Chat",
    EDIT_CASE: "Editar Caso de Chat",
    DATE: "Data",
    COUNTRY: "País",
    SKILL: "Habilidade",
    CHAT_HISTORY: "Histórico de Chat",
    SESSION_NO: "Nº da Sessão",
    AGENTNAME: "Nome do Agente",
    LASTSAVETIME: "Última Hora de Salvamento",
    SUBMITTIME: "Hora de Envio",
    STATUS: "Status",
    CASE_STATUS: "Status do Caso",
    CASE_STATUS_NEW: "Aberto",
    CASE_STATUS_FINISHED: "Fechado",
    CASE_STATUS_REQUIRED: "O status do caso é obrigatório",
    SPECIAL_FLAG_L2: "Checked with L2",
    ROOM_CHANGED:
      "A sala de chat foi alterada. O formulário do caso foi recarregado, verifique-o e envie novamente.",
    CASENO: "Nº do Caso",
    CMSSERVER: "Servidor CSM",
    ACTION: "Ação",
    DRAFT: "Rascunho",
    SUBMITTED: "Concluído",
    UNSUBMITTED: "Não enviado",
    EDIT: "Editar",
    BASIC_INFO: "Informações Básicas",
    AGENT_NAME: "Nome do Agente",
    CLIENT_NAME: "Nome do Cliente",
    PHONE: "Telefone",
    EMAIL: "Email",
    PRODUCT: "Produto",
    PRODUCT_SN: "ProductSN",
    RMANO: "Nº RMA",
    TOPIC: "Tópico",
    PROBLEM: "Problema",
    SOLUTION: "Solução",
    DATAREADY: "Dados prontos",
    OS: "Sistema Operacional",
    BTN_DRAFT: "Rascunho",
    BTN_SEND: "Enviar",
    COPY_CASENO: "O número do caso foi salvo na área de transferência",
    CASE_CREATED: "Caso de Chat já existe",
    SN_ERROR: "Por favor, insira o ProductSN correto.",
    SN_ERROR2: "SN não pode ser verificado, será enviado em branco.",
    CATA_ERROR:
      "SN correto, por favor selecione a linha de produto. (Falha STW)",
  },
  REPORT: {
    NAV: {
      TITLE: "Relatório",
      AGENTSATUS: "Status do Agente",
      AGENT_DAILYSATUS: "Status Diário do Agente",
      AGENT_DAILYSATUS_CHART: "Gráfico de Status Diário do Agente (Beta)",
      AGENT_KPIOCCUPANCY: "KPI e Ocupação do Agente (Beta)",
      CSAT: "Satisfação",
      OVERALL_AGENT_SATISFACTION: "Satisfação geral do agente (Beta)",
      OVERALL_SKILL_SATISFACTION: "Satisfação geral com as habilidades (Beta)",
      COST: "Faturamento",
      COST_REPORT: "Relatório de Faturamento",
      VIDEO_COST_REPORT: "Relatório de Faturamento de Videochamada",
      COST_HOURLY: "Estatísticas Horárias das Sessões de Chat",
      KPI: "KPI",
      KPI_REPORT: "Relatório de KPI",
      KPI_REPORT_SKILL: "Relatório de KPI com visão geral por Habilidade",
      KPI_REPORT_HOURLY: "Relatório de KPIs (por hora)",
      KPI_REPORT_SKILL_HOURLY:
        "Relatório de KPIs com visão geral de habilidades (por hora)",
      AHT_REPORT: "Relatório de AHT",
      AHT_REPORT_SKILL: "Relatório de AHT com visão geral por Habilidade",
    },
    TH_DATE: "Data",
    TH_AGENT: "Agente",
    TH_CLIENT: "Nome do Cliente",
    TH_SKILL: "Habilidade",
    TH_STARTTIME: "Hora de Início",
    TH_ENDTIME: "Hora de Término",
    TH_STATUS: "Status",
    TH_DURATION: "Duração",
    TH_CHAT: "Chat",
    TH_CHATTIME: "[C] Tempo de Chat (min)",
    TH_REAYTIME: "[R] Tempo Pronto (min)",
    TH_ACWTIME: "[ACW] Tempo ACW (min)",
    TH_AUXTIME: "[AUX] Tempo AUX (min)",
    TH_LOGINTIME: "[L] Tempo de Login (min) (R+C+ACW_AUX)",
    TH_TOTALCHAT: "[TC] Tempo Total de Chat (min)",
    TH_OCCUPANCY: "Ocupação (C/L)",
    TH_CONCURRENCY: "Concorrência (TC/L)",
    TH_AHT: "AHT",
    TH_CSAT: "CSAT",
    TH_CHANNEL: "Canal",
    TH_WAITTIME: "Tempo de Espera (Segundos)",
    TH_CUSTOMEREMAIL: "Email do Cliente",
    TH_CUSTOMERLOCATION: "Localização do Cliente",
    TH_TALKTIME: "Tempo de Conversa",
    TH_USERTALK: "O Usuário Falou ou Não",
    TH_COUNTRY: "País",
    TH_ASP: "Fornecedor de Serviço (ASP)",
    TH_CHATOFFERED: "Chats Oferecidos",
    TH_CHATANS: "Chats Respondidos",
    TH_ANSRATE: "Taxa de Resposta",
    TH_QTYABD: "Qtd. de Chats Abandonados",
    TH_ABDRATE: "Taxa de Abandono (%)",
    TH_QUEUED: "Na Fila",
    TH_MAX_TIMETOANS: "Tempo Máximo até Responder",
    TH_AVG_TIMETOANS: "Tempo Médio até Responder",
    TH_MAX_TIMETOABD: "Tempo Máximo até Abandono",
    TH_AVG_TIMETOABD: "Tempo Médio até Abandono",
    TH_AVG_CHATTIME: "Tempo Médio em Chat",
    TH_SKILLSLA: "SLA da Habilidade",
    TH_SLA60S: "SLA 60 Segundos (%)",
    TH_CHAT_RECONNECTS: "Nº de Chats Reconectados",
    TH_CHAT_RECONNECTS_RATE: "Taxa de Reconexão de Chat (%)",
    EXPORT_REGION: "Exportar Região",
    OPT_SAT: "Por favor, selecione satisfação",
    OPT_SAT_ALL: "Todos",
    OPT_SAT_SATISFIED: "Satisfeito",
    OPT_SAT_DISSATISFIED: "Insatisfeito",
  },
  ACD: {
    TITLE: "Distribuidor Automático de Monitoramento de Chat",
    AGENTSTATE: "Status do Agente",
    SERVICELEVEL: "Nível de Serviço",
    SUMMARY: "Resumo do Dia",
    TH_HANDLETIME: "Tempo de Atendimento",
    TH_AGENT: "Agente",
    TH_SKILL: "Conjunto de Habilidades",
    TH_STATUS: "Status",
    TH_STATEDURATION: "Duração do Status",
    TH_CURRENTNUM: "Chat em Andamento",
    TH_MAXNUM: "Máx. de Chats Respondidos",
    TH_PICKUPNUM: "Total de Chats Atendidos",
    TH_IDLETIME: "Tempo Ocioso do Agente",
    TH_INCOMING: "Qtd. Recebida",
    TH_ANS: "Respondidos",
    TH_ANSRATE: "Taxa de Resposta",
    TH_SLA: "SLA",
    TH_SLARATE: "SLA %",
    TH_QUEUED: "Qtd. na Fila",
    TH_MAXWAITING: "Máx. Tempo de Espera",
    TH_DISCSAT_COUNT: "Insatisfação",
    TH_CSAT_COUNT: "Satisfação",
    TH_CSAT: "CSAT",
    TH_AHT: "AHT",
    TH_CHATID: "ID do Chat",
    TH_PRODUCT: "Produto",
    TH_CUSTOMERNAME: "Nome do Cliente",
    TH_STARTTIME: "Hora de Início",
    TH_DURATION: "Duração",
    TH_LASTMESSAGETIME: "Última Mensagem Enviada",
    TH_IDLE: "Ocioso",
    F_AGENTSETTING: "Configuração do Agente",
    F_AGENTID: "ID do Agente",
    F_AGENT: "Nome do Agente",
    F_SKILL: "Habilidades do Agente",
    F_SUPPORTNUM: "Qtd. Máxima de Chats",
    D_USERCHATLIST: "Lista de Chats de ",
    D_CHATROOMINFO: "Informação da Sala de Chat",
    D_NOCHAT: "Atualmente não há sessões em andamento",
    D_PRODUCT: "Produto",
    D_PRODUCT_SN: "SN do Produto",
    D_PROBLEMTYPE: "Tipo de Problema",
    D_C_NAME: "Nome do Cliente",
    D_C_PHONENUM: "Telefone do Cliente",
    D_C_EMAIL: "Email do Cliente",
    D_C_EMPTY: "Em Branco",
    D_C_NOTE: "Observação sobre o Problema do Cliente",
    BTN_RESET_SKILL: "Redefinir Habilidade",
    RESET_CONFIRM1: "Deseja redefinir as habilidades de todos os agentes?",
    RESET_CONFIRM2: "Deseja redefinir as habilidades do agente?",
    RESET_SUCCESS: "Habilidades do agente foram redefinidas.",
    FORCE_LOGOUT: "Forçar Logout",
    FORCE_SET_AGENT_LOGOUT: "Definir Logout do Agente",
    FORCE_LOGOUT_CONFIRM:
      "Tem certeza de que deseja forçar o logout deste agente?",
    FORCE_LOGOUT_SUCCESS: "Agente foi desconectado.",
    QUEUE_NOTICE1: "Um usuário entrou na fila.",
    QUEUE_NOTICE2: "Número total na fila",
  },
  DASHBOARD: {
    TITLE: "Painel",
    CLOSED_CASE: "Caso Fechado",
    INPROCESS_CASE: "Em Processo",
    AGENT_SATUS: "Status do Agente",
    SAT: "Satisfação",
    C_AGENT_OL: "Agente caiu",
    C_AGENT_OL_I: "Dica (Agente desconectado)",
    C_CLIENT_OL: "Usuário caiu",
    C_CLIENT_OL_I: "Dica (Cliente desconectado)",
    C_TIMEOUT_OL: "Timeout",
    C_TIMEOUT_OL_I: "Dica (Desconectado por Timeout)",
    C_OTHER_OL: "Outra Desconexão",
    C_OTHER_OL_I: "Dica (Outra Desconexão)",
    C_AHT_MORE60: "Aprox. AHT (>1 min)",
    C_AHT_MORE60_I: "Dica (mais de 1 min para AHT)",
    C_AHT_IN60: "Aprox. AHT (<1 min)",
    C_AHT_IN60_I: "Dica (menos de 1 min para AHT)",
    C_AHT_OVER: "Acima do AHT",
    C_AHT_OVER_I: "Dica (Timeout de AHT)",
    C_A_READY: "Pronto",
    C_A_READY_I: "Dica (Pronto)",
    C_A_ACW: "ACW",
    C_A_ACW_I: "Dica (ACW)",
    C_A_BREAK: "AUX-Pausa",
    C_A_BREAK_I: "Dica (AUX-Pausa)",
    C_A_MEETTING: "AUX-Reunião",
    C_A_MEETTING_I: "Dica (AUX-Reunião)",
    C_SAT: "Satisfeito",
    C_SAT_I: "Dica (Satisfeito)",
    C_UNSAT: "Insatisfeito",
    C_UNSAT_I: "Dica (Insatisfeito)",
    C_NOSAT: "Sem Pesquisa",
    C_NOSAT_I: "Dica (Nenhuma Pesquisa de Satisfação realizada)",
    TH_STATUS: "Status",
    TH_AGENTNAME: "Agente",
    TH_CUSTOMER: "Cliente",
    TH_SAT: "Satisfeito",
    TH_UNSAT: "Insatisfeito",
    TH_HANDLETIME: "Tempo de Atendimento",
    TH_STARTTIME: "Hora de Início",
    TH_SURVEYTIME: "Hora da Pesquisa",
    TH_SURVEYCODE: "Resultados da Pesquisa",
  },
  SETTING: {
    INDEX: {
      PERSONAL_SETTING: "Configuração Pessoal",
      PERSONAL_EDIT_PROFILE: "Editar Perfil",
      PERSONAL_EDIT_CANNEDRESPONSE_SETTING: "Configuração de Mensagem Rápida",
      PUBLIC_CANNEDRESPONSE_LIST: "Lista Pública de Mensagens Rápidas",
      CHAT_SETTING: "Configuração de Chat",
      CHAT_BASIC_SETTING: "Configuração Básica",
      CHAT_SYSTEM_COPYWROTIN_SETTING: "Configuração de Termos do Sistema",
      CHAT_CANNEDRESPONSE_SETTING: "Configuração de Mensagens Rápidas",
      CHAT_BULLETIN_SETTING: "Configuração de Boletim Externo",
      BULLETIN_SETTING: "Configuração de Boletim",
      NOTIFY_SETTING: "Configuração de Notificação",
      COUNTRY_SETTING: "Configuração de País",
      ASP_SETTING: "Configuração ASP",
      SKILL_SETTING: "Configuração de Habilidade",
      SKILL_COUNTRY_SETTING: "Configuração de Habilidade (País)",
      SKILL_REGION_SETTING: "Configuração Pública de Habilidade (Região)",
      SKILL_SCHEDULE_SETTING: "Configuração de Agendamento de Habilidades",
      ACCOUNT_SETTING: "Configuração de Conta",
      EC_LOGIN: "Chave de Login EC",
      GPT_SETTING: "ChatBot",
    },
    PERSONAL: {
      PROFILE: {
        TITLE: "Editar Perfil",
        ACC_INFO: "Informações da Conta.",
        ACC: "Conta",
        EMAIL: "Email",
        USERNAME: "Nome de Usuário",
        CURRENTPSW: "Senha Atual",
        NEWPSW: "Nova Senha",
        NEWPSW2: "Confirmar Nova Senha",
        BASIC_SETTING: "Configuração Básica",
        AVATAR: "Foto de Perfil",
        UPLOAD_AVATAR: "Enviar/Alterar Foto de Perfil",
        NAME: "Nome",
        FIRSTNAME: "Nome",
        LASTNAME: "Sobrenome",
        NICKNAME: "Apelido",
        GENDER: "Gênero",
        MALE: "Masculino",
        FEMALE: "Feminino",
        LAN: "Idioma",
        KBLAN: "Idioma Preferido do KB",
      },
    },
    CANNED: {
      PERSONAL_CANNED_SETTING: "Mensagem Rápida Pessoal",
      EDIT_PERSONAL_CANNED: "Editar Mensagem Rápida Pessoal",
      EDIT_PUBLIC_CANNED: "Editar Mensagem Rápida Pública",
      CREATE_PERSONAL_CANNED: "Criar Mensagem Rápida Pessoal",
      CREATE_PUBLIC_CANNED: "Criar Mensagem Rápida Pública",
      EDIR_GROUP: "Editar Grupo Personalizado",
      CREATE_CANNED: "Criar",
      IMPORT_CANNED: "Importar",
      EXPORT_CANNED: "Exportar",
      SELECT_FILE: "Por favor, selecione o arquivo",
      DOWNLOAD_SAMPLE: "Baixar arquivo de exemplo",
      CREATE_GROUP: "Criar grupo",
      CREATE_CATE: "Criar grupo",
      EDIT_GROUP: "Editar grupo",
      EDIT_CATE: "Editar categoria",
      GROUP_NAME: "Nome do grupo",
      CATE_NAME: "Nome da categoria",
      SELECTED_FILE: "Arquivo selecionado",
      SELECT_GROUP: "Selecione o grupo",
      SELECT_GROUP_FIRST: "Selecione o grupo primeiro",
      SELECT_CATE: "Selecione a categoria",
      ENTER_SHORTCUTS: "Digite as palavras-chave",
      TH_GROUP: "Grupo",
      TH_CATE: "Categoria",
      TH_SHORTCUTS: "Palavra-chave",
      TH_CONTENT: "Conteúdo da mensagem",
      TH_CREATOR: "Criador",
      TH_ACTION: "Ação",
      EMPTYTEXT: "Nenhuma mensagem rápida criada ainda",
      SHORTCUT_INFO:
        "Para usar mensagens rápidas durante o chat, insira # e a palavra-chave. Você pode separar cada palavra-chave por vírgula e também configurar várias palavras-chave para a mesma mensagem",
      NO_GROUP: "Nenhum grupo criado",
      NO_CATE: "Nenhuma categoria criada",
      BEFORE_DELETE_CANNED:
        "Tem certeza de que deseja excluir esta mensagem rápida?",
      BEFORE_DELETE_CATE: "Tem certeza de que deseja excluir a categoria?",
      BEFORE_DELETE_GROUP: "Tem certeza de que deseja excluir o grupo?",
      PUBLIC_CANNED_SELECT_COUNTRY:
        "Configuração de mensagem rápida pública - Selecione seu país",
      PUBLIC_CANNED: "Mensagem rápida pública",
      MANAGE_GROUP: "Gerenciar Categoria de Produto",
      AGENT_CANNED: "Mensagens rápidas dos agentes",
      IDLE_QUICK: "Resposta rápida ociosa",
    },
    CHAT: {
      BASIC: {
        CHATLIST_FILTER: "Otimização da Busca da Lista de Chats",
        CHATLIST_FILTER_INTRO: "Quando ativado, a lista de chats do agente carrega todos os chats não finalizados e os chats finalizados cujo horário de término esteja dentro do período de retenção definido aqui, em vez de todos os chats do dia.",
        SELECT_COUNTRY: "Configuração Básica - Selecione o País",
        TITLE: "Configuração Básica",
        TRANSFER: "Transferência de Arquivo",
        FILE_TYPE: "Formatos de arquivo suportados",
        IMAGE_TYPE: "Formatos de imagem suportados",
        AGENT_SEND_FILE: 'Permitir que o agente envie "Arquivo" para o cliente',
        AGENT_SEND_IMAGE: 'Permitir que o agente envie "Imagem" para o cliente',
        AGENT_FILE_LIMIT: 'Tamanho máx. do "Arquivo" enviado pelo agente',
        AGENT_IMAGE_LIMIT: 'Tamanho máx. da "Imagem" enviada pelo agente',
        PIC_ENCRYPTED: "Imagem criptografada",
        CLIENT_SEND_FILE:
          'Permitir que o cliente envie "Arquivo" para o agente',
        CLIENT_SEND_IMAGE:
          'Permitir que o cliente envie "Imagem" para o agente',
        CLIENT_FILE_LIMIT: 'Tamanho máx. do "Arquivo" enviado pelo cliente',
        CLIENT_IMAGE_LIMIT: 'Tamanho máx. da "Imagem" enviada pelo cliente',
        AGENT_DELETE_MSG: "Agente pode retirar mensagem",
        AUTO_DAYLIGHT_SAVING: "Ajuste automático de horário de verão",
        PICKUP_TIME: "Tempo de buffer de recebimento (segundos)",
        SHOW_SURVEY_RUIE1: "Condição para exibir pesquisa (Tempo)(segundo)",
        SHOW_SURVEY_RULE1_INTRO:
          "Se o tempo de conversa for menor que o tempo definido, significa que o usuário entrou no chat sem conversa. Nenhuma pesquisa será exibida.",
        SHOW_SURVEY_RUIE2: "Condição para exibir pesquisa (Mensagem)(Qtd)",
        SHOW_SURVEY_RULE2_INTRO:
          "Se o número de mensagens do cliente for menor que o definido, significa que o usuário entrou no chat sem conversa. Nenhuma pesquisa será exibida.",
        SHOW_SURVEY_RUIE3: "Fala do usuário é condição necessária",
        SHOW_SURVEY_RULE3_INTRO:
          "Se o usuário entrar no chat sem conversa, nenhuma pesquisa será exibida.",
        AGENT_IDLE_TIMEOUT: "Lembrete de inatividade",
        AGENT_IDLE_TIMEOUT_INTRO: "Período de espera para lembrar o agente",
        IS_AGENT_IDLE:
          "O lembrete de inatividade só será ativado quando a última mensagem for enviada pelo cliente.",
        VIDEOCALL_SETTING: "Configuração de Videochamada",
        ISRMANO: "Necessário informar Nº RMA",
        URL_SETTING: "Configuração de URL",
        OFFICIAL_URL: "URL do site oficial",
        ACCOUNT_URL: "URL da conta",
      },
      COPYRIGHT: {
        SELECT_COUNTRY: "Configuração de Direitos Autorais - Selecione o País",
        TITLE_BEFORECHAT: "Configuração de Direitos Autorais - Antes do Chat",
        TITLE_ONCHAT: "Configuração de Direitos Autorais - Na Sala de Chat",
        TITLE_SAT: "Configuração de Direitos Autorais - Satisfação",
        TITLE_EC_SAT: "Pesquisa para Loja Online",
        TITLE_VIDEOCALL: "Configuração de Direitos Autorais - Videochamada",
        TAB: {
          BEFORECHAT: "Anúncios",
          ONCHAT: "Verbiagem do chat",
          SAT: "Pesquisa",
          EC_TITLE: "Pesquisa para Loja Online",
          VIDEOCALL: "Videochamada",
        },
        BEFORECHAT: {
          COPYRIGHT: "Configuração de Direitos Autorais",
          SAT_CONSENT: "Consentimento de Satisfação",
          WELCOME: "Saudação pré-chat",
          BBY: "Declaração BBY",
          NOSERVICE: "Horário sem serviço",
          SERVICE: "Horário de serviço",
          UNSERVICE: "Serviço indisponível",
          BUSY: "Agente ocupado",
          AGE_CHECK: "Idade para E-Commerce",
          AGE_LIMIT: "Limite de Idade",
          NonServiceProduct: "Produto sem serviço",
        },
        SERVICE_TYPE: {
          TITLE: "Tipo de Serviço",
          OPTION: "Opção",
          SN: "Verificação de SN",
          SN_CHECK:
            "O recurso permite apenas usuários com SN válido acessarem o serviço.",
        },
        ONCHAT: {
          SELFINTRO: "Autoapresentação do agente",
          SELFINTRO_INFO:
            "Exemplo: Olá! Sou o especialista de atendimento online {Agent_Name} e estou muito feliz em atendê-lo. Como posso ajudar?",
          IDLE_NOTICE: "Aviso de tempo limite",
          IDEL_NOTICE_TIME: "Tempo de inatividade (s)",
          IDEL_NOTICE_TIME_INTRO:
            "Quando o cliente estiver inativo por mais tempo que o definido, uma mensagem de inatividade será exibida. (Unidade: Segundo)",
          IDLE_DISCONNECT: "Tempo limite",
          IDLE_DISCONNECT_TIME: "Tempo de desconexão (s)",
          IDLE_DISCONNECT_TIME_INTRO:
            "Quando o cliente se desconectar por mais tempo que o definido, a mensagem de desconexão será exibida. (Unidade: segundo)",
          TRANSFER_AGENT: "Verbiagem de agente transferido",
          TRANSFER_AGENT_INTRO:
            "Exemplo: Olá! Sou {Agent_Name}, o agente responsável por {Skill_Name}, prazer em atendê-lo. Onde posso ajudar?",
          BEFOREFINISH: "Aviso para usuário desconectado",
          AGENT_DISCONNECT: "Aviso para agente desconectado",
          CHAT_EXPORT: "Exportação de chat",
          BUTTON_1: "Botão 1",
          BUTTON_2: "Botão 2",
          BUTTON_PLACEHOLDER: "Insira o texto do botão.",
          FINISH_OPTION_1:
            "Botão 1. Serviço concluído e seguir para pesquisa de satisfação.",
          FINISH_OPTION_2: "Botão 2. Contatar agente de atendimento online",
          EXPORT_ALLOW: "Permitir download",
          EXPORT_WELCOME_TEXT:
            "Mensagem de boas-vindas para download do arquivo",
          EXPORT_PRIVACY_BTN: "Botão de Privacidade",
          EXPORT_PRIVACY_LINK: "Insira o link de privacidade.",
          EXPORT_TERMS_BTN: "Botão de Termos",
          EXPORT_TERMS_LINK: "Insira o link dos termos.",
          YOUTUBE_NOTE:
            "Se permanecer em branco, o ícone direcionará para o canal global do YouTube: ",
        },
        SAT: {
          ISSURVEY: "Pesquisa Obrigatória",
          SATISFIED: "Satisfeito",
          UNSATISFIED: "Insatisfeito",
          PLACEHOLDER: "Digite o motivo/feedback",
          OPTION: "Opção",
          OTHER: "Outro",
          OTHER_INFO:
            "Após ativar a pesquisa, os campos para preenchimento aparecerão para o cliente.",
        },
        VIDEOCALL: {
          COPYRIGHT: "Configuração de Direitos Autorais",
          SAT: "Pesquisa para Videochamada",
          EMAIL: "Configuração de Email",
          CONTENT_EXAMPLE_1:
            "Uma imagem de QR Code e uma imagem 'Clique aqui' com o link serão incluídas nos emails enviados aos clientes. Por favor, insira as duas strings a seguir (incluindo símbolos { }) no texto:",
          CONTENT_EXAMPLE_2:
            "1. {qrcode_image} colocado onde deseja exibir o QR Code.",
          CONTENT_EXAMPLE_3:
            "2. {qrcode_link} colocado próximo ao texto 'Clique aqui' que deseja exibir.",
        },
      },
      BULLETIN: {
        SELECT_COUNTRY: "Boletim Externo - Selecione o País",
        TITLE_LIST: "Boletim externo",
        TITLE_CREATE: "Criar boletim externo",
        TITLE_EDIT: "Editar boletim externo",
      },
    },
    BULLETIN: {
      SELECT_COUNTRY: "Configuração de Boletim - Selecione o País",
      TITLE_LIST: "Configurações de boletim interno",
      TITLE_CREATE: "Criar boletim interno",
      TITLE_EDIT: "Editar boletim interno",
      FORM_DATE: "Data de criação do boletim",
      FORM_TO: "até",
      FORM_STARTDATE: "Data de início",
      FORM_ENDDATE: "Data de término",
      FORM_CATEGORY: "Categoria",
      FORM_CATE_GENERAL: "Geral",
      FORM_CATE_EMERGENCY: "Urgente",
      FORM_CATE_NONSERVICE: "Sem Serviço",
      FORM_STATUS: "Status",
      FORM_UNPUBLISHED: "Não publicado",
      FORM_PUBLISHED: "Publicado",
      TH_DATE: "Data de Criação",
      TH_CONTENT: "Conteúdo",
      TH_CATEGORY: "Categoria",
      TH_COUNTRY: "País",
      TH_STATUS: "Status",
      TH_STARTTIME: "Início",
      TH_ENDTIME: "Término",
      C_SELECT_COUNTRY: "Selecione o País",
      C_TARGET: "Publicar para",
      C_TARGET_AGENT: "Agente",
      C_TARGET_CLIENT: "Cliente",
      C_CATEGORY: "Categoria da Mensagem",
      C_SKILLGROUP: "Grupo de Habilidade",
      C_CONTENT: "Conteúdo",
      C_LINK: "Link",
      C_ISSCHED: "Agendar",
      C_ISSCHED_YES: "Sim",
      C_ISSCHED_NO: "Não",
      C_SCHED_STARTTIME: "Agendamento Inicia em",
      C_SCHED_ENDTIME: "Agendamento Termina em",
      E_STATUS: "Ocultar?",
      E_STATUS_ACTIVE: "Sim",
      E_STATUS_INACTIVE: "Não",
    },
    NOTICE: {
      SELECT_COUNTRY: "Configuração de Notificação - Selecione o País",
      SELECT_ASP: "Configuração de Notificação - Selecione o ASP",
      TITLE: "Configuração de Notificação",
      SUBTITLE: "Condições para acionar e opções de configuração",
      NOTICE_01: "Número de pessoas aguardando na fila",
      NOTICE_02: "Intervalo muito longo",
      NOTICE_03: "ACW muito longo",
      NOTICE_04: "Nenhum agente disponível no horário de serviço",
      NOTICE_05: "Notificação de login/logout do agente",
      NOTICE_06: "Alteração de status do agente",
      NOTICE_07: "Tempo de HT do agente muito longo",
      NOTICE_08: "Rede do agente anormal",
      NOTICE_09: "DSAT",
      NOTICE_10: "Detecção de Anomalia de Volume de Entrada (Beta)",
      LABEL_ONOFF: "DESLIGADO/LIGADO",
      LABEL_NOTICETARGET: "Notificar",
      LABEL_LINEUP: "Qtd. na fila",
      LABEL_AUX: "AUX",
      LABEL_ACW: "ACW",
      LABEL_HT: "Tempo de HT do agente",
      LABEL_TRIGGER: "Taxa de disparo",
    },
    COUNTRY: {
      TITLE: "Lista de Países",
      SELECT_COUNTRY: "Selecione o País",
      EDIT_COUNTRY: "Editar País",
      COUNTRY_CODE: "Código do País",
      COUTNRY_NAME: "Nome do País",
      REGION: "Região",
      TIMEZONE: "Fuso horário",
      DST: "Horário de Verão",
      ADD_DST: "Adicionar DST",
      LINK: "Link",
      COPY_LINK_SUCCESS: "Link salvo com sucesso na área de transferência.",
      IS_ASUSLOGIN: "O cliente precisa fazer login?",
      IS_MAILVERIFY: "Verificação de Email Secundária",
    },
    ASP: {
      SELECT_COUNTRY: "Configuração ASP - Selecione o País",
      TITLE: "Lista de ASP",
      TH_COUNTRY: "ID do País",
      TH_ASPNAME: "Nome do ASP",
      TH_ASPSKILL: "Habilidade",
      TH_ASPCOUNT: "Quantidade de ASP",
      TH_SUPPORT_COUNTRY: "País Suportado",
      TH_ISACTIVE: "Serviço Ativo ou Não",
      TH_NOTE: "O escritório marcado é um ASP com suporte multinacional",
      FORM_TITLE_CREATE: "Criar ASP",
      FORM_TITLE_EDIT: "Gerenciamento de ASP",
      FORM_NAME: "Nome do ASP",
      FORM_ON: "Serviço ativado",
      FORM_ON_TIPS: "Ativar e o ASP pode fornecer serviços.",
      FORM_ITEM: "Itens de serviço (habilidades)",
      FORM_ITEM_TIPS: "Habilidades de serviço fornecidas pelo ASP",
      FORM_TRANSFER: "Transferido entre Agentes",
      FORM_TRANSFER_TIPS:
        "Com esta opção ativada, agentes sob o mesmo ASP podem transferir habilidades de serviço entre si",
      FORM_TRANSFER_ASP: "Pode transferir para outro ASP",
      FORM_TRANSFER_ASP_TIPS: "Transferir para outro ASP no mesmo país",
      FORM_TRNASFER_COUNTRY: "Suporte a ASP multinacional",
      FORM_TRNASFER_COUNTRY_TIPS:
        "Suporte a serviços ASP nos mesmos países/regiões. Deixe em branco se não estiver disponível",
    },
    SKILL: {
      COUNTRY: {
        SELECT_COUNTRY:
          "Configuração de Habilidade por País - Selecione o País",
        TITLE: "Gerenciar Habilidade por País",
        TH_SINGLE_SERVICE: "Tempo Único de Serviço",
        TH_SINGLE_SERVICE_INFO:
          "O horário de serviço de todas as habilidades seguirá a configuração do 'Tempo Único de Serviço'.",
        TH_SKILL_GLOBAL: "Habilidade (Global)",
        TH_SKILL_TAG: "Habilidade (TAG)",
        TH_SKILL_LOCAL: "Nome da Habilidade (Local)",
        TH_HANDLETIME: "Tempo de Atendimento",
        TH_DAY: "Dia",
        TH_TIME: "Hora",
        TH_NOTE: "Horário de Serviço da Habilidade",
        FORM_TITLE_CREATE: "Criar nova Habilidade",
        FORM_TITLE_EDIT: "Editar/Gerenciar Habilidade",
        FORM_SUBTITLE_1: "Configurações de Habilidade",
        FORM_SUBTITLE_2: "Adicionar Horário de Serviço",
        FORM_SUBTITLE_3: "Horário de Serviço",
        FORM_SKILL: "Habilidade",
        FORM_SKILL_LOCAL: "Nome da Habilidade (Local)",
        FORM_SKILL_STATUS: "Status da Habilidade",
        FORM_SKILL_DISPLAY: "Exibir",
        FORM_SKILL_HIDDEN: "Oculto",
        FORM_HANDLETIME: "Tempo de Atendimento da Habilidade",
        FORM_PRODUCT: "Produto",
        FORM_SELECTDAY: "Selecione a Data",
        FORM_STARTTIME: "Hora de Início",
        FORM_ENDTIME: "Hora de Término",
        FORM_ADD: "Habilidade adicionada em",
        OFFDAY: "Dia de folga",
      },
      REGION: {
        TITLE: "Configuração de Habilidade Regional",
        SKILL_GLOBAL: "Nome da Habilidade (Global)",
        SKILL_TAG: "Nome da Habilidade (TAG)",
      },
      SCHE: {
        SELECT_COUNTRY: "Agendamento de Folga de Habilidade - Selecione o país",
        TITLE: "Agendamento de Folga de Habilidade",
      },
    },
    ACC: {
      TITLE: "Gerenciamento de Conta",
      TITLE_CREATE: "Criar nova Conta",
      TITLE_EDIT: "Editar Conta",
      COUNTRY: "País",
      USERNAME: "Nome de usuário",
      ROLE: "Função",
      ASP: "ASP",
      SKILL: "Habilidade",
      WEBRTC: "Videochamada Lite",
      EMAIL: "Email",
      IS_FAKE_EMAIL: "Email Não Recebido",
      CHANGE_PSW: "Alterar Senha",
      PSW: "Senha",
      PSWCONFIRM: "Confirmar Senha",
      RANDOM_PSW: "Senha Aleatória & Copiar",
      STATUS: "Ativar Conta",
      MAXSERVICECOUNT: "Qtd. máx. de chats",
      ISSERVICE: "Prestar serviço",
      ISSERVICE_TRANSFER_ONLY: "Apenas para Transferência de Casos",
      MANUAL_TRANSFER_ONLY: "Apenas transferência manual",
      ACD_MONITOR: "Configurações de Monitoramento ACD",
      USERNAME_INFO:
        "Insira de 6 a 20 caracteres (números misturados com letras).",
      PASSWORD_INFO: "Siga o formato de senha abaixo.",
      ACC_SETTING: "Configuração de Conta",
      BASIC_SETTING: "Configuração Básica",
      AVATAR: "Foto de Perfil",
      UPLOAD_AVATAR: "Enviar/Alterar Foto de Perfil",
      NAME: "Nome",
      FIRSTNAME: "Nome",
      LASTNAME: "Sobrenome",
      NICKNAME: "Apelido",
      GENDER: "Gênero",
      MALE: "Masculino",
      FEMALE: "Feminino",
    },
    SELECT_COUNTRY: {
      COUNTRYCODE: "Código do País",
      COUNTRYNAME: "Nome do País",
    },
    EC_LOGIN: {
      TITLE: "Loja Online - Configuração para login ASUS",
      DESC: "Para exigir login de membro ASUS do cliente, ative esta configuração.",
      TH_REGION: "Região",
      TH_COUNTRYNAME: "País",
      TH_ACTION: "Ação",
    },
    GPT: {
      SELECT_COUNTRY: "Configuração do ChatBot - Selecione o País",
      TITLE: "Configuração Básica do ChatBot",
      SYSTEM: {
        TITLE: "Configuração de Copiar Sistema",
        PRIVACY: "Declaração de Privacidade",
        SERVICE_TITLE: "Anúncio de Horário de Serviço/Não Serviço",
        SERVICE: "Anúncio de Horário de Serviço",
        NON_SERVICE: "Anúncio de Horário sem Serviço",
        NON_SERVICE_REPLY: "Resposta de Horário sem Serviço",
        NON_SERVICE_BTN: "Texto do Botão",
        NON_SERVICE_URL: "Insira a URL",
        IDLE: "Usuário Inativo",
        IDLE_LABEL: "Aviso de Inatividade (S)",
        IDLE_DESC:
          "Quando o usuário estiver inativo além do tempo, uma mensagem de inatividade será exibida. (Unidade: segundos)",
        OFFLINE: "Usuário Desconectado",
        OFFLINE_MSG: "Mensagem Offline",
        OFFLINE_TIME: "Tempo Offline (S)",
        OFFLINE_DESC:
          "Quando o usuário permanecer inativo além do tempo, uma mensagem de desconexão será exibida. (Unidade: segundos)",
        SENTENCE: "Limite de Conversas",
        SENTENCE_MSG: "Mensagem de Término do Serviço",
        SENTENCE_LABEL: "Configuração de quantidade de conversas (vezes)",
        SENTENCE_DESC:
          "Quando o número de conversas exceder o limite especificado, uma mensagem de término será exibida. (Unidade: vezes)",
        IP_LIMIT_LABEL: "Limite diário de respostas da IA por IP (vezes)",
        IP_LIMIT_DESC:
          "Quando um IP exceder o limite diário de respostas da IA, uma mensagem de término será exibida. A Decision Tree não é afetada. (Unidade: vezes)",
        SAT: "Contagem de Insatisfação (deslikes)",
        SAT_LABEL: "Contagem de deslikes",
        SAT_DESC:
          "Se o usuário não gostar da resposta do BOT por um determinado número de vezes, será exibida mensagem para transferência a um agente. (Unidade: vezes)",
        SAT_SWITCH: "Pesquisa de satisfação",
        SAT_DISLIKE: "Motivo do Desgosto",
        TOAGENT: "Acionar para Agente",
        TOAGENT_MSG: "Mensagem de Acionamento para Agente",
        TOAGENT_LABEL: "Configuração de Parâmetro (vezes)",
        TOAGENT_DESC:
          "Exibe mensagem de transferência para agente. (Unidade: vezes)",
        AD: "Configuração de Anúncio",
        AD_URL: "Insira a URL",
        AD_PIC: "Upload de Nova Imagem (Tamanho Recomendado 330*120)",
        AD_NEW: "Adicionar Anúncio",
        BOT: "Configuração de Mensagem/Resposta do BOT",
        BOT_LABEL: "Mensagem",
        BOT_NEW: "Adicionar Mensagem",
        BOT_WELCOME: "Mensagem de Boas-vindas",
        BOT_TEC: "Resposta de Suporte Técnico",
        BOT_PRODUCT: "Resposta de Linha de Produto",
        BOT_BOT: "Introdução à Solução do BOT",
        BOT_END: "Mensagem de Encerramento do Chat",
        BOT_NOSERVICE: "Horário sem Serviço",
        BOT_REPAIR: {
          TITLE: "Configuração de Resposta de Status de Reparo",
          INPUT: "Diretrizes de Entrada SN/RMA Nº",
          RECORD: "Registros de Reparo Encontrados",
          NORECORD: "Registros de Reparo Não Encontrados (Desativado)",
          NOSN: "SN Não Encontrado",
          ERRORTIMES: "Limite de Erro de SN",
          TOAGENT: "Mensagem de Acionamento para Agente",
        },
        BOT_WARRANTY: {
          TITLE: "Configuração de Resposta de Garantia",
          INPUT: "Diretrizes de Entrada SN/RMA Nº",
          RECORD: "Garantia Encontrada",
          NORECORD: "Garantia Não Encontrada (Desativado)",
          NOSN: "SN Não Encontrado",
          ERRORTIMES: "Limite de Erro de SN",
          TOAGENT: "Mensagem de Acionamento para Agente",
        },
      },
      DECISION_TREE: "Configuração de Árvore de Decisão",
      TREE: {
        NORMAL: "Normal",
        NAME: "Nome",
        STYLE: "Estilo",
        OPTION: "Opções",
        EDIT: "Editar",
        SORT: "Ordenar",
        NEWLAYER: "Nova Camada",
        EDITLAYER: "Editar Camada",
        KEYNAME: "Intenção",
        TITLE: "Título",
        SUBTITLE: "Subtítulo",
        IS_SURVEY: "Like/Dislike",
        DISPLAY: "Exibir",
        TOAGENT: "Apenas para Agente",
        TOAGENT_DESC: "Descrição",
        TOAGENT_NONSERVICE: "Resposta Personalizada de Horário sem Serviço",
        LINK_STYLE: "Configuração de Estilo de Link",
        LINK: "Link",
        LINK_BTNTEX: "Texto do Botão",
        LINK_BLANK: "Abrir em nova janela",
        CARD_STYLE: "Configuração de Estilo de Cartão",
        CARD_IMAGE: "Imagem",
        CARD_BTNTEXT: "Texto do Botão",
        GPTLINK: "Linha de Produto",
        CHILD_LAYER_STYLE: "Estilo da lista de subcamadas",
        CHILE_LAYER_OPT1: "Texto",
        CHILE_LAYER_OPT2: "Link",
        CHILE_LAYER_OPT3: "Link (com BOT)",
        CHILE_LAYER_OPT4: "Cartão (com link)",
        CHILE_LAYER_OPT5: "Cartão (com BOT)",
        CHILD_LAYER_OPT_DESC:
          "※O estilo apresentado pela lista de subcamadas (se houver)",
        CHILD_LAYER_DESC: "Descrição da lista de subcamadas",
        TUTORIAL: "Tutorial",
        TUTORIAL_MODE: "Modo Tutorial",
        TUTORIAL_INTENT: "Intenção",
        TUTORIAL_TITLE: "Título",
        TUTORIAL_CONTENT: "Conteúdo",
        TUTORIAL_ICON: "Ícone",
        TUTORIAL_NEW: "Adicionar Tutorial",
      },
      SAT: {
        TITLE: "Configuração de Opção de Pesquisa de Satisfação",
      },
      SN_BLOCK: {
        TITLE: "Configuração de Lista de SN Bloqueados",
      },
    },
  },
  NOTIFY: {
    ROLE: "Função",
    AREA: "Área",
    STATUS_SETTING: "Configuração de Status",
    LOGIN: "Login",
    READY: "Pronto",
    BREAK: "Intervalo",
    LUNCH: "Almoço",
    ACW: "Trabalho Pós-Chat",
    MEETING: "Reunião",
    COACHING: "Treinamento Interno",
    LOGOUT: "Logout",
  },
  MESSAGECENTER: {
    TITLE: "Central de Mensagens",
    NO_MSG: "Nenhuma mensagem",
    CHANGEPSW: "Por favor, atualize sua nova senha antes de {date}.",
    KB_LAG: "Por favor, complete a configuração do idioma preferido do KB",
    FIRST_CHANGEPSW:
      "Para garantir a segurança da sua conta, recomendamos alterar sua senha regularmente. Gostaria de alterá-la agora? Clique em 'Confirmar' para prosseguir ou em 'Depois' para fazer isso mais tarde.",
  },
  VIDEO: {
    VIDEO_READY: "Videochamada já em andamento.",
    CONFIRM: {
      TITLE: "Iniciar convite de videochamada (Beta)",
      TEXT: "Tem certeza de que deseja enviar o convite de videochamada? (Beta)",
      HANGUP: "Desligar",
      HANGUP_TEXT: "Tem certeza de que deseja encerrar a videochamada?",
    },
    MESSAGE: {
      INVITE_MSG:
        'Você enviou um convite de videochamada ao cliente. Para cancelar o convite, clique em "Cancelar Convite de Videochamada".',
      CANCEL_INVITE: "Cancelar Convite de Videochamada",
    },
    LAYOUT: {
      DEVICE_NOT_FOUND: "Webcam não encontrada.",
      DEVICE_NOT_FOUND_INFO:
        "Seu dispositivo não foi detectado, certifique-se de ter permitido o uso da câmera e microfone ou que o dispositivo não esteja em uso por outro aplicativo.",
      LOCAL_WEBCAM: "Seu vídeo",
      DRAG: "Clique aqui para arrastar a janela",
      CLIENT_HANGUP: "O cliente encerrou a videochamada",
      CLIENT_REFUSES: "A outra parte recusou o convite de videochamada",
    },
  },
  VIDEOCALL: {
    TITLE: "Video Call Lite (Beta)",
    READY: "Ready for Video Call",
    ENDED: "Video Call Ended",
    WAITING: "Waiting for client connection...",
    IN_PROGRESS: "Video Call in Progress",
    BACK_TO_CURRENT: "Back to Current Chat",
    RECORD_ING: "Recording",
    RECORD_PAUSE: "Recording Paused",
    RECORD_END: "Recording Ended",
    CREATE: {
      SN_ERROR: "Número de série inválido.",
    },
    CUSTOMER_ENDED: "Customer has ended the Video Call",
    END: "End The Video Call",
    END_DESC:
      "Whether to close the chat room, press 'Confirm' to end the chat room. (Users can no longer enter chat rooms through links.)",
  },
  FUNNEL: {
    TITLE: "Gráfico de Funil (Beta)",
    ENTER_URL: "Por favor, insira a URL",
    RESULT: "Resultado",
  },
};
export default pt_BR;
